module.exports = __webpack_public_path__ + "static/img_1512-8f9a747a1ef223a42e4c7fbbe70ed260.webp";